import { Pipe, PipeTransform } from '@angular/core';
import {WP_REST_API_Post} from "wp-types";
import {PageExtended} from "../models/Page/PageExtended";

@Pipe({
  name: 'whenPageCategorie',
  standalone: true,
  pure: false
})
export class WhenPageCategoriePipe implements PipeTransform {

  transform(pages: PageExtended[]|null, term_id?: number): PageExtended[] {
    if(!pages) return [];
    return pages.filter((p)=>{
      return term_id ? p.page_categories.find((pc)=>pc.term_id == term_id) : true;
    })
  }

}
